import { render } from "./giveMethod.vue?vue&type=template&id=03458b64&scoped=true"
import script from "./giveMethod.vue?vue&type=script&lang=js"
export * from "./giveMethod.vue?vue&type=script&lang=js"

import "./giveMethod.vue?vue&type=style&index=0&id=03458b64&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03458b64"]])

export default __exports__